import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import Loading from '@/components/circle-loading'

const ButtonGradientEpic: FC<{
	children: React.ReactNode
	className?: string
	type?: 'button' | 'submit' | 'reset'
	onClick?: (evt: any) => void
	disabled?: boolean
	loading?: boolean
	size?: 'small' | 'medium' | 'large' | 'x-large'
	'data-testid'?: string
}> = (props): ReactElement => {
	const sizeClasses = {
		'small': 'px-3 py-1.5 text-sm',
		'medium': 'px-4 py-2 text-sm',
		'large': 'px-6 py-2.5 text-sm',
		'x-large': 'px-8 py-3 text-sm'
	}[props.size || 'medium']

	return (
		<button
			disabled={props.disabled}
			onClick={props?.onClick}
			data-testid={props['data-testid']}
			className={classNames(
				'relative rounded-md font-medium transition-all duration-200 text-white',
				'bg-gradient-to-r from-purple-600 to-blue-500 hover:from-purple-700 hover:to-blue-600',
				'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-purple-600 disabled:hover:to-blue-500',
				sizeClasses,
				props.className
			)}
			type={props.type || 'button'}
		>
			{props?.loading ? <Loading /> : props.children}
		</button>
	)
}

export default ButtonGradientEpic
